export default "/assets/bb5327f217817961.png"